import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import './BibleReadingPage.scss';
import './BibleReadingPageFonts.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import { IonCard, IonCardContent, IonCardHeader, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonIcon, IonImg, IonItem, IonLabel, IonList, IonModal, IonNote, IonPage, IonRow, IonSkeletonText, IonText, IonToast, NavContext, useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react';
import BibleTextService from '../../services/BibleTextService';
import BSTAudioPlayer, { IRemotePlayPauseAudio } from '../../components/BSTAudioPlayer/BSTAudioPlayer';
import ReadingPlanRecordService from '../../services/ReadingPlanRecordService';
import IReadingPlanSession from '../../interfaces/IReadingPlanSession';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector, } from 'react-redux';
import { SelectActiveReadingPlanRecord, SelectActiveSession, SelectBibleColorTheme, SelectBibleTabActive, SelectIsGroupPlanAdmin, SelectLastVersion, SelectLastViewedURL, SelectReadingPlans, SelectScheduledSession, SelectScheduledURL, SelectSelectedVerse, UpdateActivePlanByIdAsync, UpdateActiveReadingPlanRecord, UpdateActiveSession, UpdateBibleColorTheme, UpdateBibleTabActive, UpdateLastVersion, UpdateLastViewedURL, UpdateSelectedVerse } from '../../store/BibleStudySlice';
import BibleVersions, { AllBibleVersions, BibleVersionCopyright, BibleVersionNames, BibleVersionsValues } from '../../data/BibleVersions';
import { book, calendar, checkbox, share, square, squareOutline, checkboxOutline, remove, closeCircle, closeSharp, chevronBack, chevronForward, chatbubblesSharp, copySharp, play, removeCircleOutline, addCircleOutline, chevronForwardCircleSharp, checkmarkCircleOutline, library, send, star } from 'ionicons/icons';
import AudioTextTrackingIcon from '../../assets/images/audio-text-tracking.svg';
import { SelectLoginStatus } from '../../store/UserSlice';
import PostTypes, { PostTypesValues } from '../../data/PostTypes';
import IReadingPlanRecord from '../../interfaces/IReadingPlanRecord';
import BibleReadingHeader from '../../components/BibleReadingHeader/BibleReadingHeader';
import { PageTransitionFade } from '../../data/PageTransitionFade';
import BibleContent, { AllBibleContent, BibleContentData, BibleContentLocation, BibleContentValues } from '../../data/BibleContent';
import BibleGoogleMap from '../../components/BibleGoogleMap/BibleGoogleMap';
import BibleVideos from '../../components/BibleVideos/BibleVideos';
import BibleImages from '../../components/BibleImages/BibleImages';
import CountDownTimer from '../../components/CountDownTimer/CountDownTimer';
import { BibleBookNamesType } from '../../data/BibleBookNames';
import IPrayer from '../../interfaces/IPrayer';
import PrayerStatus from '../../data/PrayerStatus';
import PrayerService from '../../services/PrayerService';
import IBibleVerse from '../../interfaces/IBibleVerse';
import PrayerIcon from '../../assets/images/prayerLogo.svg';
import NewPostIcon from '../../assets/images/chatbubble-sharp-plus.svg';
import { Share } from '@capacitor/share';
import BibleSettingsService from '../../services/BibleSettingsService';
import IBibleSettings from '../../interfaces/IBibleSettings';
import { DefaultBibleSettings } from '../../data/DefaultBibleSettings';
import NetworkStatusContext from '../../components/NetworkStatusContext/NetworkStatusContext';
import FeedbackModal from '../../components/FeedbackModal/FeedbackModal';
import SelectReadingPlanPopUp from '../../components/SelectReadingPlanPopUp/SelectReadingPlanPopUp';
import { AllReadingPlanCodes, ReadingPlanCodeValues, ReadingPlanCodes, createDefaultReadingPlanRecord } from '../../data/ReadingPlans';
import { SelectGroupIds } from '../../store/FellowshipSlice';
import DismissibleCard from '../../components/DismissibleCard/DismissibleCard';
import { AppMessages } from '../../data/AppMessages';
import IDismissibleMessage from '../../interfaces/IDismissibleMessage';
import DismissibleMessageService from '../../services/DismissibleMessageService';
import BibleColorThemes, { BibleColorThemesValues } from '../../data/BibleColorThemes';
import { searchBibleChapterIndex } from '../../data/BibleChapterIndex';

const BibleReadingPage: React.FC<IRouteInfo> = (props:IRouteInfo) => {

  // -------------------------------------------------------------------
  // #region PrivateVariables private variables and use objects/methods
  // -------------------------------------------------------------------

  const history = useHistory();
  const dispatch = useDispatch();
  const NetworkService = useContext(NetworkStatusContext);
  const {navigate} = useContext(NavContext);
  const [bibleText, setBibleText] = useState<JSX.Element[][]>([]);
  const [audioBibleFile, setAudioBibleFile] = useState<string | undefined>('');
  const { planCode, session, version } = useParams<{ planCode: string; session: string; version: string;}>();
  const scheduledReadingSessionURL = useSelector(SelectScheduledURL);
  const scheduledReadingSession = useSelector(SelectScheduledSession);
  const lastViewBibleSessionURL = useSelector(SelectLastViewedURL);
  const activeSession = useSelector(SelectActiveSession);
  const readingPlanRecord = useSelector(SelectActiveReadingPlanRecord);
  const readingPlans = useSelector(SelectReadingPlans); 
  const isReadingPlanAdmin = useSelector(SelectIsGroupPlanAdmin);
  const LoggedIn = useSelector(SelectLoginStatus);
  const userGroupsIds = useSelector(SelectGroupIds);
  const lastSelectedVersion = useSelector(SelectLastVersion);
  const selectedVerse = useSelector(SelectSelectedVerse);
  const bibleTabActive = useSelector(SelectBibleTabActive);
  const bibleColorTheme = useSelector(SelectBibleColorTheme);
  const [bibleDarkMode, setBibleDarkMode] = useState(false);
  const [showFooterSlide, setShowFooterSlide] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [activeModalContent, setActiveModalContent] = useState<BibleContentValues>(BibleContent.kmlMap)
  const [activeFooterContent, setActiveFooterContent] = useState<BibleContentValues>(BibleContent.questions);
  const [showAudioBible, setShowAudioBible] = useState(true);
  const [showNavButtons, setShowNavButtons] = useState(true);
  const [showSmallPlayButton, setShowSmallPlayButton] = useState(true);
  const [extraResourcesURL, setExtraResourcesURL] = useState('');
  const pageContent = useRef<HTMLIonContentElement>(null);
  const passageGroup = useRef<HTMLDivElement[]>([]);
  const verseReferences = useRef<HTMLSpanElement[]>([]);
  const visiblePassages = useRef<{passage: string, visible: boolean}[]>([]);
  const [visibleReference, setVisibleReference] = useState('');
  const audioPlayerRef = useRef<IRemotePlayPauseAudio>(null);
  const activeSessionRef = useRef<number>(activeSession?.session);
  const readingPlanRecordRef = useRef<IReadingPlanRecord>(readingPlanRecord);
  const headerRef = useRef<HTMLIonHeaderElement>(null);
  const audioScrollEnabled = useRef<boolean>(true);
  const [displayToastSuccess, setDisplayToastSuccess] = useState(false);
  const [toastSuccessMessage, setToastSuccessMessage] = useState('Success: Added New Prayer.');
  const [displayToastFailed, setDisplayToastFailed] = useState(false);
  const [toastFailedMessage, setToastFailedMessage] = useState('Error');
  const [showShareButton, setShowShareButton] = useState(false);
  const [activeBibleSettings, setActiveBibleSettings] = useState<IBibleSettings | undefined>();
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [hideReadingHeaderInstructions, setHideReadingHeaderInstructions] = useState(false);
  const [showCompletedPlan, setShowCompletedPlan] = useState(false);
  const [freestyleIndex, setFreestyleIndex] = useState(0);
  const [noPlanBible, setNoPlanBible] = useState<boolean>(false);
  const biblePassagesRequests = useRef<any[]>([]);
  const subscribedBibleTextRequest = useRef<boolean>(false);

  // -------------------------------------------------------------------
  // #endregion
  // -------------------------------------------------------------------
  // #region UseEffects useEffect methods
  // -------------------------------------------------------------------

  // ENSURE CHECK TOGGLE HAS APPROPRIATE VALUE
  useEffect(() => {
    readingPlanRecordRef.current = readingPlanRecord;
    activeSessionRef.current = activeSession?.session;
    setNoPlanBible(readingPlanRecordRef?.current?.readingPlanCode === ReadingPlanCodes.bible)
  }, [readingPlanRecord, activeSession]);


  // UPDATE DEFAULT VERSION IN BIBLE SETTINGS
  useEffect(() => {
    if(activeBibleSettings) {
      const updatedBibleVersion = getValidBibleVersion(lastSelectedVersion!);
      const updatedBibleSettings = {...activeBibleSettings, defaultVersion: updatedBibleVersion};
      BibleSettingsService.updateBibleSettings(updatedBibleSettings).then(result => console.log(result));
    }
  },[lastSelectedVersion]);

  // ENSURE GROUP READING PLANS ARE LOADED
  useEffect(() => {
    if(userGroupsIds.length) {
      UpdateActivePlanByIdAsync(dispatch, userGroupsIds);
    }
  },[userGroupsIds]);

  // MONITORS CURRENT VISIBLE VERSES
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entry) => {
        entry.forEach((passages) => {
          const foundIndex = visiblePassages.current.findIndex(verse => verse?.passage === passages.target.id);
          if(foundIndex >= 0)
          {
            visiblePassages.current[foundIndex].visible = passages.isIntersecting;
            if(passages.isIntersecting && visiblePassages.current.length === (foundIndex + 1) && !readingPlanRecord?.completedSessions[+session - 1]) {
              toggleCheckedBox(true);

              if(readingPlanRecord?.completedSessions && +session === readingPlanRecord?.completedSessions.length) {
                setShowCompletedPlan(true);
              }
            }
          }      
        });
        
        let searchingTopVisible = true;
        visiblePassages.current
          .filter(verse => verse.visible === true)
          .forEach((passages) => {
            if(passages && searchingTopVisible) {
              searchingTopVisible = false;
              setVisibleReference(passages.passage);
            }
        })
      }
    )

    if(bibleText.length && verseReferences.current.length) {
      verseReferences.current.forEach(passages => {
        if(passages) {
          observer.observe(passages);
        }
      })
    }
    return () => {
      observer.disconnect();
    }
  }, [bibleText]);

  // -------------------------------------------------------------------
  // #endregion
  // -------------------------------------------------------------------
  // #region PageInit Initial page loading functions
  // -------------------------------------------------------------------

  // MANAGES ACTIVE READING PLAN SESSION
  useIonViewDidEnter(() => {
    const currentURL = urlBuilder();

    // load Bible Settings
    if(!activeBibleSettings) {
      loadBibleSettings();
    }

    // if Session changed and the active reading plan changed, get the plan and load the session
    if(lastViewBibleSessionURL !== currentURL && readingPlanRecord?.readingPlanCode !== planCode) {
      ReadingPlanRecordService.getReadingPlanRecords().then(async records => {
        const matchingRecords = records.Success ? records.Data?.filter(record => record?.readingPlanCode === planCode) : undefined;

        if(matchingRecords?.length && matchingRecords.find(plan => !plan.groupId || userGroupsIds.find(id => plan.groupId === id))) {
          // If the active record has a matching code then use it, but if not use the first match
          const currentRecord = matchingRecords.find(record => record.id === readingPlanRecord?.id);
          const selectedRecord = currentRecord ? currentRecord : matchingRecords[0];
          //dispatch(UpdateActiveReadingPlanRecord(selectedRecord));
          loadActiveSession(selectedRecord!);
          // We reset the selected Record Id here and when UpdateActivePlanByIdAsync is called below it will dispatch the active plan record
          await loadBibleSettings(selectedRecord.id);
        } else {
          // if the plan in URL exists and the session is in the URL, 
          // create a new plan record and display the session
          const readingPlanCode = AllReadingPlanCodes.find(code => code === planCode) ? 
            planCode as ReadingPlanCodeValues : undefined;
          if(readingPlanCode && +session !== 0) {
            const createPlanResult = await ReadingPlanRecordService.createReadingPlanRecord(
              createDefaultReadingPlanRecord(readingPlanCode))
                .catch(error => { 
                  console.error(error);
                  failedLoadRedirect();
                });
            if(createPlanResult && createPlanResult.Success) {
              loadActiveSession(createPlanResult.Data!);
              UpdateActivePlanByIdAsync(dispatch, userGroupsIds, createPlanResult.Data?.id);
            }
            else {
              console.log('Failed to Create Plan');
              failedLoadRedirect();
            }
          } else {
            failedLoadRedirect();
          }
        }
      });
    } else {
      loadActiveSession(readingPlanRecord);
    }

    // Make sure the scheduled reading plan day is loaded.
    if(!scheduledReadingSessionURL) {
      UpdateActivePlanByIdAsync(dispatch, userGroupsIds, readingPlanRecord?.id);
    }

    Share.canShare().then(result => {
      if(result.value) {
        setShowShareButton(true);
      }
    });

    if(!bibleTabActive) {
      dispatch(UpdateBibleTabActive(true));
    }

  }, [planCode, session, version, lastViewBibleSessionURL, userGroupsIds, bibleTabActive]);
  
  // LET APP KNOW THE BIBLE PAGE HAS BEEN LEFT
  useIonViewDidLeave(() => {
    if(bibleTabActive) {
      dispatch(UpdateBibleTabActive(false));
    }
  }, [bibleTabActive]);

  // LOAD BIBLE PAGE SETTINGS
  const loadBibleSettings = async (activeReadingPlanId?: number) => {
    const bibleSettingsResponse =  await BibleSettingsService.getBibleSettings();
    if(bibleSettingsResponse.Success) {
      const activeSettings = activeReadingPlanId === undefined ? 
        bibleSettingsResponse.Data! :
        {...bibleSettingsResponse.Data!, activeReadingPlanId};
      setActiveBibleSettings(activeSettings);
      audioScrollEnabled.current = !!activeSettings.audioScroll;
      setBibleDarkMode(activeSettings.colorTheme === BibleColorThemes.darkMode);
      dispatch(UpdateBibleColorTheme(activeSettings.colorTheme));
      if(activeReadingPlanId !== undefined) {
        await BibleSettingsService.updateBibleSettings(activeSettings);
      }
    } else {
      BibleSettingsService.createBibleSettings(DefaultBibleSettings).then(result => {
        console.log(result.Success ? 'Created BibleSettings' : 'Failed To Create BibleSettings');
        setActiveBibleSettings(DefaultBibleSettings);
        audioScrollEnabled.current = !!DefaultBibleSettings.audioScroll;
        setBibleDarkMode(DefaultBibleSettings.colorTheme === BibleColorThemes.darkMode);
        dispatch(UpdateBibleColorTheme(DefaultBibleSettings.colorTheme));
      });
    } 
  }

  // LOAD CURRENT BIBLE STUDY SESSION
  const loadActiveSession = async (record: IReadingPlanRecord) => {
    // Limit session to possible values
    const newSession = +session > record.completedSessions.length ?
    record.completedSessions.length :
      +session < 1 ? 1 :
      +session;
    const currentURL = urlBuilder();
    const urlSplitArray = lastViewBibleSessionURL?.split('/');
    const lastPlanCode = urlSplitArray && urlSplitArray.length >= 3 ? urlSplitArray[2] : '';

    if(activeSession?.session !== newSession || lastPlanCode !== planCode || lastSelectedVersion !== version) {
      const response = await ReadingPlanRecordService.getSession!(record, newSession.toString())
        .catch(error => console.error("Failed Session Fetch", error));
      if(response?.Success) {
        pageContent.current && pageContent.current.scrollToTop();
        setExtraResourcesURL(`${record?.sessionsURL}extra-resources.jpg`);
        visiblePassages.current = [];
        const selectedSession = response.Data as IReadingPlanSession;
        const updatedBibleVersion = getValidBibleVersion(version);
        dispatch(UpdateLastVersion(updatedBibleVersion));
        dispatch(UpdateActiveSession(selectedSession));  
        updateBibleText(record, selectedSession, updatedBibleVersion);
        if(readingPlanRecordRef?.current?.readingPlanCode === ReadingPlanCodes.bible) {
          setLastChapterReadInNoPlan(selectedSession.id);
        }     
      }
    }

    if(lastViewBibleSessionURL !== currentURL) {
      dispatch(UpdateLastViewedURL(currentURL));
    }
  }

  // -------------------------------------------------------------------
  // #endregion PageInit Initial page loading functions
  // -------------------------------------------------------------------
  // #region HelperFunctions local page helper functions
  // -------------------------------------------------------------------

  const getValidBibleVersion = (bibleVersionString: string): BibleVersionsValues => {
    return AllBibleVersions.find(bibleVersion => bibleVersion === bibleVersionString) ?? DefaultBibleSettings.defaultVersion;
  };

  const urlBuilder = (sessionOffset: number = 0, updatedVersion = version) => {
    const updatedSession = +session + sessionOffset;
    const updatedBibleVersion = getValidBibleVersion(updatedVersion);
    return `/bible/${planCode}/${updatedSession}/${updatedBibleVersion}`;
  }

  const getSelectedVerse = async(reference: string) => {
    const verseText = await (await BibleTextService.getVerseText(reference, getValidBibleVersion(version))).versePromise;
    dispatch(UpdateSelectedVerse(verseText));
  }

  const failedLoadRedirect = () => {
    history.push(`${AppRouteInfo[AppRouteKeys.ReadingScheduler].rootPath}/${ReadingPlanCodes.ccrbrp}/new`, {direction: 'back'});
  }

  const LinkSessionURL = (sessionOffset: number = 0) => {
    if((+session + sessionOffset) === 0) {
      return '';
    } else if (readingPlanRecord?.completedSessions && sessionOffset !== -1 && +session + sessionOffset > readingPlanRecord?.completedSessions.length) {
      return '';
    } else {
      if(+session > readingPlanRecord?.completedSessions.length) {
        return urlBuilder(-(+session - readingPlanRecord?.completedSessions.length + 1))
      } else {
        return urlBuilder(sessionOffset);
      }
    }
  }

  const goToBibleSession = (intervalAdvancement: number) => {
    setShowFeedbackModal(false);
    navigate(LinkSessionURL(intervalAdvancement), 'forward','push', PageTransitionFade);
  }

  // NOTE: Since this gets called by completedDay and it is called from within a window.setIntertval
  // all values in it need to be passed by reference otherwise they will get locked because of closure.
  // examples: activeSessionRef, readingPlanRecordRef
  const toggleCheckedBox = (markRead?: boolean) => {
    const sessionArrayValue = activeSessionRef.current ? activeSessionRef.current - 1 : +session - 1;
    if (readingPlanRecordRef.current){
      const completedSessions = [...readingPlanRecordRef.current.completedSessions];
      const updatedPlan = {...readingPlanRecordRef.current};
      completedSessions[sessionArrayValue] = markRead !== undefined ? markRead : !completedSessions[sessionArrayValue];
      updatedPlan.completedSessions = completedSessions;
      ReadingPlanRecordService.updateReadingPlanRecord(updatedPlan).then(result => {
        if(result.Success) {
          dispatch(UpdateActiveReadingPlanRecord(result.Data));
        }
      });
    }
  }

  const completedDay = () => {
    toggleCheckedBox(true);
    if(+session >= 5) {
      setShowFeedbackModal(true);
    }
  }

  const toggleBibleContentDisplay = (contentType: BibleContentValues) => {
    switch (BibleContentData[contentType].location) {
      case BibleContentLocation.footer:
        setActiveFooterContent(contentType);
        setShowFooterSlide(!showFooterSlide);
        setShowAudioBible(!showAudioBible);
        setShowNavButtons(!showNavButtons);
        setShowModal(false);
        break;
      case BibleContentLocation.modal:
        setActiveModalContent(contentType);
        setShowFooterSlide(false);
        setShowAudioBible(true);
        setShowNavButtons(true);
        setShowModal(true);
        break;
      default:
        break;
    }
  }

  const shareDay = () => {
    let sharePath = AppRouteInfo[AppRouteKeys.FellowshipCreatePost].path;
    sharePath = sharePath.replace(':postType?', PostTypes.bible.toString());
    sharePath = sharePath.replace(':shareIdentifier?', session);

    history.push(sharePath, {direction: 'forward'});
  }

  const shareBible = (postType: PostTypesValues, identifier: string) => {
    let sharePath = AppRouteInfo[AppRouteKeys.FellowshipCreatePost].path;
    sharePath = sharePath.replace(':postType?', postType.toString());
    sharePath = sharePath.replace(':shareIdentifier?', identifier);
    if(LoggedIn) {
      history.push(sharePath, {direction: 'forward'});
    } else {
      setToastFailedMessage('Please Login To Your Group To Share.');
      setDisplayToastFailed(true);
    }
  }

  const savePrayer = async (bibleVerse: IBibleVerse) => {
    const today = new Date(Date.now());
      const currentPrayer: IPrayer = {
      id: 0,
      title: bibleVerse.displayReference ? bibleVerse?.displayReference : '',
      description: `${bibleVerse?.text}(${BibleVersionNames[bibleVerse.version]})`,
      status: PrayerStatus.active,
      modifiedDate: today,
      createdDate: today,
      order: Date.now(),
      linkedPostId: undefined,
    };
    
    const response = await PrayerService.createPrayer(currentPrayer);
    if(response.Success) {
      setToastSuccessMessage('PRAY ADDED TO YOUR LIST')
      setDisplayToastSuccess(true);
    }
  }

  const copyVerse = (bibleVerse: IBibleVerse) => {
    var tempInput = document.createElement("textarea");
    tempInput.style.cssText = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = `${bibleVerse.text} (${bibleVerse.displayReference} ${BibleVersionNames[bibleVerse.version]}) \nhttps://BibleStudyTogether.com`;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    setToastSuccessMessage('Verse copied to Clipboard!')
    setDisplayToastSuccess(true);
  }

  const shareBibleOnDevice = (bibleVerse: IBibleVerse) => {
    Share.share({
      title: `Bible Study Together Verse:`,
      text: `"${bibleVerse.text}" (${bibleVerse.displayReference} ${BibleVersionNames[bibleVerse.version]})\n `,
      url: `https://app.biblestudytogether.com${lastViewBibleSessionURL}`,
      dialogTitle: `Bible Study Together: ${bibleVerse.displayReference}`,
    });
  }

  const startAudioPlayer = () => {
    if(NetworkService?.isListening && NetworkService.networkConnected) {
      console.log('Session #', session, activeSession);
      setShowSmallPlayButton(false);
      audioPlayerRef.current?.remotePlayPauseAudio();
    } else {
      setToastFailedMessage('NO INTERNET CONNECTION DETECTED - Connection is required to play audio.');
      setDisplayToastFailed(true);
    }
  }

  const updateVerseScroll = (verseId: string) => {
    if (verseId && audioScrollEnabled.current) {
      const verseRef = verseReferences.current.find(verse => verse.id === verseId);
      const elementBox = verseRef?.getBoundingClientRect();
      const headerBox = headerRef.current?.getBoundingClientRect();

      if(elementBox && headerBox) {
        const scrollPosition = elementBox.top - headerBox.bottom - 2;
        console.log(verseId, scrollPosition);
        pageContent.current?.scrollByPoint(0, scrollPosition, 1000);
      }
    }
  }

  const getColorThemeClass = (colorTheme?: BibleColorThemesValues) => {
    switch(colorTheme) {
      case BibleColorThemes.darkMode:
        return 'bible-reading-dark-mode';
      default:
        return '';
    }
  }

  const toggleBibleDarkMode = () => {
    if(activeBibleSettings){
      // select the opposite color theme
      const colorTheme = bibleColorTheme === BibleColorThemes.default ? BibleColorThemes.darkMode : BibleColorThemes.default;
      const updatedBibleSettings = {...activeBibleSettings, colorTheme}
      BibleSettingsService.updateBibleSettings(updatedBibleSettings).then(result => {
          if(result.Success) {
              setActiveBibleSettings(result.Data!);
              setBibleDarkMode(colorTheme === BibleColorThemes.darkMode);
              dispatch(UpdateBibleColorTheme(colorTheme));
          }
      });
    }
  }

  const toggleAutoScrollBox = () => {
    if(activeBibleSettings){
      const updatedBibleSettings = 
        {...activeBibleSettings, audioScroll: !activeBibleSettings.audioScroll}
      BibleSettingsService.updateBibleSettings(updatedBibleSettings).then(result => {
          if(result.Success) {
              setActiveBibleSettings(result.Data!);
              audioScrollEnabled.current = !!result.Data!.audioScroll
          }
      });
    }
  }

  const adjustFontSize = (adjustment: number) => {
    if(activeBibleSettings){
      const newSize = activeBibleSettings?.fontSize + adjustment;
      if(newSize <= 17 && newSize >= 12) {
        const updatedBibleSettings = 
          {...activeBibleSettings, fontSize: newSize}
        BibleSettingsService.updateBibleSettings(updatedBibleSettings).then(result => {
            if(result.Success) {
                setActiveBibleSettings(result.Data!);
                audioScrollEnabled.current = !!result.Data!.audioScroll
            }
        });
      }
    }
  }

  const dismissReadingHeaderInstructions = (messageId: string, initiateAction: boolean) => {
    const dismissMessage: IDismissibleMessage = {
      messageId,
      category: props.title,
      timesDisplayed: 1,
      dateDisplayed: new Date(Date.now()),
      dismissed: true,
    }
    DismissibleMessageService.logDismissibleMessage(dismissMessage).then(
      result => {
        if(result.Success) {
          setHideReadingHeaderInstructions(true);
        }
        console.log(result);
      }
    );
  }

  const updateActiveFreestyleIndex = (activeIndex: number, planSession: IReadingPlanSession) => {
    verseReferences.current = [];
    setFreestyleIndex(activeIndex);
    const activePassage: string = planSession.biblePassageList[activeIndex];
    updateFreestyleAudioFile(planSession, activeIndex, version);
    pageContent?.current?.scrollToTop(1000);
    
    if(readingPlanRecordRef.current){
      const updatedPlan = {...readingPlanRecordRef.current};
      updatedPlan.lastFreeStylePassage = activePassage;
      ReadingPlanRecordService.updateReadingPlanRecord(updatedPlan).then(result => {
        console.log('Active Passage: ', activePassage);
        if(result.Success) {
          dispatch(UpdateActiveReadingPlanRecord(result.Data));
          console.log('Active Passage Success: ', result.Data);
        }
      });
    }
  }

  const updateFreestyleAudioFile = (planSession: IReadingPlanSession, activeIndex: number, bibleVersion: string) => {
    // Currently on ESV is supported
    if(bibleVersion === BibleVersions.esv && planSession) {
      const activePassage: string = planSession?.biblePassageList[activeIndex];
      const bibleReference = BibleTextService.parseBibleReference(activePassage);
      if(bibleReference) {
        const tempBaseURL = `https://biblestudytogether.com/${bibleVersion}-audio-chapter-bible/`;
        const audioFile = `${tempBaseURL}${bibleReference.book}+${bibleReference.startChapter}.mp3`;
        setAudioBibleFile(audioFile);
        setShowSmallPlayButton(true);
      } else {
        setAudioBibleFile('');
        setShowSmallPlayButton(false);
      }
    } else {
      setAudioBibleFile('');
      setShowSmallPlayButton(false);
    }
  }

  const navigatePlan = (noReadingPlanId: number) => {
    if(noReadingPlanId) {
        history.push(`${AppRouteInfo[AppRouteKeys.BibleNavigator].rootPath}/${noReadingPlanId}`, {direction: 'forward'});
    } else {
        history.push(AppRouteInfo[AppRouteKeys.BibleStudyBrowser].path, {direction: 'forward'});
    }
  }

  const setLastChapterReadInNoPlan = (session: number) => {
    if(readingPlanRecordRef.current){
      const updatedPlan = {...readingPlanRecordRef.current};
      const result = searchBibleChapterIndex(session);
      if(result) {
        const activePassage: string = `${result.book} ${result.chapter}`;
        updatedPlan.lastFreeStylePassage = activePassage;
        ReadingPlanRecordService.updateReadingPlanRecord(updatedPlan).then(result => {
          console.log('Active Passage: ', activePassage);
          if(result.Success) {
            dispatch(UpdateActiveReadingPlanRecord(result.Data));
            console.log('Active Passage Success: ', result.Data);
          }
        });
      }
    }
  }

  // -------------------------------------------------------------------
  // #endregion HelperFunctions local page helper functions
    // -------------------------------------------------------------------
  // #region LoadBibleText loading active Bible text
  // -------------------------------------------------------------------

  // LOAD BIBLE TEXT AND AUDIO
  const updateBibleText = (record: IReadingPlanRecord, planSession: IReadingPlanSession, bibleVersion: string) => { 
    subscribedBibleTextRequest.current = false;
    biblePassagesRequests.current.length && biblePassagesRequests.current.forEach(request => request.cancel());
    
    if(planSession && bibleVersion && record) {
      console.log('bibleText altered', planSession?.freeStyleBibleReading, record?.lastFreeStylePassage);
      visiblePassages.current = [];
      verseReferences.current = [];
      biblePassagesRequests.current = [];
      subscribedBibleTextRequest.current = true;
      audioPlayerRef.current?.remoteResetPlayer();
      if(planSession?.freeStyleBibleReading && record?.lastFreeStylePassage) {
        const passageIndex = planSession?.biblePassageList?.findIndex(passage => passage === record?.lastFreeStylePassage);
        setFreestyleIndex(passageIndex !== -1 ? passageIndex : 0);
        updateFreestyleAudioFile(planSession, passageIndex, bibleVersion);
      } else {
        const selectedAudioBible = planSession.audioBibles?.find(audioBible => audioBible.translation === bibleVersion);
        setAudioBibleFile(selectedAudioBible?.url);
        setShowSmallPlayButton(true);
      }
      const passageList = planSession?.biblePassageList;
      biblePassagesRequests.current = passageList.map(passage => 
        BibleTextService.getBookText(
          passage, bibleVersion, 
          noPlanBible ? 'none' : 'before' , 
          true, true, true, openExtraVerseOptions, populateVerseReferences));
      const biblePassagesPromises = biblePassagesRequests.current.map(request => request.bibleTextPromise);
      Promise.all(biblePassagesPromises!).then(result => {
        const renderedPassages: JSX.Element[][] = [];
        result.forEach((passages: JSX.Element[]) => {
          // For rendering the text in the reader
          renderedPassages.push(passages);
          // For rendering the active verse in the header
          passages.forEach(passage => {
            if(passage.props?.verse) {
              const visiblePassageObject = createVisibleVerseObject(passage.props.book, passage.props.chapter, passage.props.verse);
              if(!visiblePassages.current.find(object => object.passage === visiblePassageObject.passage)) {
                visiblePassages.current.push(visiblePassageObject);
              }
            }
          });
        });
        subscribedBibleTextRequest.current && setBibleText(renderedPassages);
      }).catch(error => {
        console.log(error);
      });
    }
  };

  // RENDERS THE JSX BIBLE TEXT
  const renderBibleText = (freestyle: boolean, biblePassages: JSX.Element[][], activePassageIndex?: number) => {
    const activePassageGroup = activePassageIndex !== undefined ? activePassageIndex : 0;
    return biblePassages.map((passages, index:number) => {
      passageGroup.current = [];
      if((freestyle && index === activePassageGroup) || !freestyle) {
        return (
          <div key={'biblePassages' + index} 
            id={'passages-' + index} 
            className={'bible-reading-passages-section'} 
            ref={(element: HTMLDivElement) => element && passageGroup.current.push(element)}
          >
            {passages.map((text, textIndex: number) => <Fragment key={'bibleText' + textIndex}>{text}</Fragment>
            )}
          </div>)
      } else {
        return ''
      }
    });
  }
  
  // USED FOR DISPLAYING VERSE REFERENCE AT THE TOP OF THE PAGE
  const createVisibleVerseObject = (book: BibleBookNamesType, chapter: number, verse: number) => {
    return{ passage: `${book} ${chapter}:${verse}`, visible: false }
  }
  const populateVerseReferences = (element: HTMLSpanElement) => element && verseReferences.current.push(element);
  const openExtraVerseOptions = (book: BibleBookNamesType, chapter: number, verse: number) => {
    const bibleVerse = `${book} ${chapter}:${verse}`;
    getSelectedVerse(bibleVerse);
    toggleBibleContentDisplay(BibleContent.verse);
  }

  // -------------------------------------------------------------------
  // #endregion LoadBibleText loading active Bible text
  // -------------------------------------------------------------------
  // #region  PageContentRender render page content
  // -------------------------------------------------------------------

  const renderBibleContent = (contentType: BibleContentValues) => {
    switch (contentType) {
      case BibleContent.questions:
        return <div>
                  { activeSession?.questions?.map((question: string, index) => 
                    <div className="bst-question-list-item" key={'bstQuestion' + index}>
                      <div className="question-number"><span>{index + 1}</span></div>
                      <div className="question-text">{question}</div>
                      <div className="question-share" hidden={!LoggedIn}>
                        <IonIcon className="post-2-fellowship-page-icon" icon={NewPostIcon} title="Post an answer to your group's fellowship page. "
                          onClick={() => shareBible(PostTypes.bibleQuestion, (index + 1).toString())} />
                      </div>
                    </div>
                  )}
                  <div hidden={!LoggedIn}><em><b>INSTRUCTIONS:</b> To see your group discussions and any answers posted by your group use the <IonIcon color="tertiary" icon={chatbubblesSharp}></IonIcon> in the top right corner of the app. 
                  To post your own answer to your group's fellowship discussion page, you can use the <IonIcon color="tertiary" icon={NewPostIcon}></IonIcon> next to the questions.</em></div>
                </div>
      case BibleContent.challenges:
        return <ol>
                  { activeSession?.challenges?.map((challenge: string, index) => 
                    <li key={'bstChallenge' + index}>{challenge}</li>
                  )}
                </ol>
      case BibleContent.kmlMap:
        return activeSession?.kmlMap ? <BibleGoogleMap kmlUrl={activeSession?.kmlMap}></BibleGoogleMap> :
                    'Unable to load Bible Map.'
      case BibleContent.videos:
        return activeSession?.videos?.length ? <BibleVideos videos={activeSession.videos}></BibleVideos> :
          'Unable to load Bible Videos.'
      case BibleContent.images:
        return activeSession?.images?.length ? <BibleImages images={activeSession.images}></BibleImages> :
          'Unable to load Bible Images.'
      case BibleContent.verse:
        return  <div>
                  <IonGrid>
                    <IonRow className='verse-content-options-row'>
                      <IonCol>
                        <button className="verse-content-options verse-content-options-fellowship"
                          onClick={()=> shareBible(PostTypes.bibleVerse, 'selectedVerse')}>
                          <IonIcon slot='icon-only' icon={chatbubblesSharp}></IonIcon>
                          <IonText>GROUP<br />SHARE</IonText>
                        </button>
                      </IonCol>
                      <IonCol>
                        <button className="verse-content-options verse-content-options-bible"
                          onClick={()=> selectedVerse && copyVerse(selectedVerse)}>
                          <IonIcon slot='icon-only' icon={copySharp}></IonIcon>
                          <IonText>COPY<br />VERSE</IonText>
                        </button>
                      </IonCol>
                      <IonCol>
                        <button className="verse-content-options verse-content-options-prayer"
                          onClick={()=> selectedVerse && savePrayer(selectedVerse)}>
                          <IonIcon slot='icon-only' src={PrayerIcon}></IonIcon>
                          <IonText>ADD TO<br />PRAYERS</IonText>
                        </button>
                      </IonCol>
                      { showShareButton && <IonCol>
                        <button className="verse-content-options verse-content-options-bible"
                          onClick={()=> selectedVerse && shareBibleOnDevice(selectedVerse)}>
                          <IonIcon slot='icon-only' icon={share}></IonIcon>
                          <IonText>DEVICE<br />SHARE</IonText>
                        </button>
                      </IonCol> }
                    </IonRow>
                  </IonGrid>
                </div>
      default:
        break;
    }
  }

  const skeletonText = () => {
    const skeleton = [];
    for (let i: number = 0; i < 20; i++) {
      skeleton.push(<p key={`bible-text-skeleton-${i}`}><IonSkeletonText animated /></p>)
    }
    return skeleton.map(text => text);
  }
  
  const completedReadingPlan = () => {
    return <IonModal id="completed-plan-modal" isOpen={showCompletedPlan} onDidDismiss={()=>setShowCompletedPlan(false)}>
      <IonIcon icon={checkmarkCircleOutline} /><p>Completed<br />Bible Plan!</p>
    </IonModal>
  }

  const freestyleVerseList = (planSession: IReadingPlanSession, position: string) => {
    return planSession.biblePassageList.map((passage, index) => 
      <li className={freestyleIndex === index ? 'verse-list-box-highlighted' : ''}
        onClick={()=> updateActiveFreestyleIndex(index, planSession)} key={`${position}-${index}`}>
        { freestyleIndex === index && <IonIcon icon={star } /> } {BibleTextService.convertToFullBookName(passage)}
      </li>
    );
  }

  const getTodaysReadings = (activeReading: number, todaysReading: number, totalSessions: number) => {
    const todaysReadings: JSX.Element[] = [];
    for (let index = todaysReading; index < (todaysReading + totalSessions); index++) {
      const reading = index < (todaysReading + totalSessions - 1) ? `${index}, ` : `${index}`;
      if(index === activeReading) {
        todaysReadings.push(<IonText className="bible-reading-pace-highlight" key={`reading-highlight-${index}-${Date.now()}`}><b>{reading}</b></IonText>);
      } else {
        todaysReadings.push(<span key={`reading-${index}-${Date.now()}`}>{reading}</span>);
      }
      
    }
    return todaysReadings;
  }

  const bibleStudyHeaderMenuContent = 
  <IonList className={`bible-study-page-menu-list ${getColorThemeClass(bibleColorTheme)}`}>
    { activeBibleSettings && 
      <IonItem>
        <IonLabel className="txt-center">FONT SIZE</IonLabel>
        <IonIcon slot="start" icon={removeCircleOutline} onClick={() => adjustFontSize(-1)} color={activeBibleSettings?.fontSize === 12 ? 'primary-light' : ''}></IonIcon>
        <IonIcon slot="end" icon={addCircleOutline} onClick={() => adjustFontSize(1)} color={activeBibleSettings?.fontSize === 17 ? 'primary-light' : ''}></IonIcon>
      </IonItem> 
    }
    <IonItem onClick={()=>{navigatePlan(noPlanBible ? activeSession.id : 0)}}>
      <IonLabel>{noPlanBible? 'NAVIGATE BIBLE' : 'BROWSE DAYS'}</IonLabel>
      <IonIcon slot="start" icon={book}></IonIcon>
    </IonItem>
    <IonItem onClick={()=>{toggleAutoScrollBox()}}>
      <IonLabel>
        AUTO TEXT SCROLL
      </IonLabel>
      <IonIcon slot="start" icon={activeBibleSettings?.audioScroll ? checkbox : square}></IonIcon>
    </IonItem>
    <IonItem onClick={()=>{toggleBibleDarkMode()}}>
      <IonLabel>
        DARK READING MODE
      </IonLabel>
      <IonIcon slot="start" icon={bibleDarkMode ? checkbox : square}></IonIcon>
    </IonItem>
    { !noPlanBible && <IonItem onClick={()=>{toggleCheckedBox()}}>
      <IonLabel>
        {readingPlanRecord?.completedSessions[+session - 1] ? 'MARK AS UNREAD' : 'MARK AS READ'}
      </IonLabel>
      <IonIcon slot="start" icon={readingPlanRecord?.completedSessions[+session - 1] ? checkbox : square}></IonIcon>
    </IonItem>}
    { !noPlanBible && <IonItem onClick={shareDay} className={!LoggedIn ? 'hidden' : ''}>
      <IonLabel>SHARE WITH GROUP</IonLabel>
      <IonIcon slot="start" icon={share}></IonIcon>
    </IonItem>}
    { !noPlanBible && <IonItem routerLink={scheduledReadingSessionURL}>
      <IonLabel>GO TO SCHEDULED</IonLabel>
      <IonIcon slot="start" icon={calendar}></IonIcon>
    </IonItem>}
    { isReadingPlanAdmin && !noPlanBible &&
    <IonItem lines="none" onClick={()=>{ history.push(
      `${AppRouteInfo[AppRouteKeys.ReadingScheduler].rootPath}/${readingPlanRecord?.readingPlanCode}/${readingPlanRecord?.id}`, {direction: 'forward'}) }}>
      <IonLabel>RESET CURRENT DAY</IonLabel>
      <IonIcon slot="start" icon={calendar}></IonIcon>
    </IonItem>}
  </IonList>

  const bibleVersionsMenuContent = 
  <IonList className={`bible-study-page-menu-list ${getColorThemeClass(bibleColorTheme)}`}>
    {AllBibleVersions.map((activeVersion, index) => 
      <IonItem key={'bibleVersion' + index} onClick={()=>{
          navigate(urlBuilder(0, activeVersion), 'forward', 'push', PageTransitionFade); 
        }}>
        { version === activeVersion ? 
          <IonIcon slot="start" icon={checkboxOutline} className="bible-version-arrow"></IonIcon> :
          <IonIcon slot="start" icon={squareOutline} className="bible-version-arrow"></IonIcon>
        }
        <IonLabel>{BibleVersionNames[activeVersion]}</IonLabel>
        <IonNote slot="end" mode="ios">
          { activeSession?.audioBibles?.find(audioBible => audioBible.translation === activeVersion) ? 
            <span> <IonIcon icon={AudioTextTrackingIcon} /><IonIcon icon={remove} /> </span> :
            ''
          }
          <IonIcon icon={book} />
        </IonNote>
      </IonItem>
    )}
  </IonList>;

  return (
    <IonPage className={getColorThemeClass(bibleColorTheme)}>
        <BibleReadingHeader {...props} 
          previousReadingSessionUrl={LinkSessionURL(-1)}
          nextReadingSessionUrl={ LinkSessionURL(1) }
          menuContent={bibleStudyHeaderMenuContent}
          checkedBox={readingPlanRecord ? readingPlanRecord.completedSessions[+session - 1] : false}
          toggleReadDay={toggleCheckedBox}
          bibleVersion={getValidBibleVersion(version)}
          versionMenuContent={bibleVersionsMenuContent}
          bibleReference={visibleReference}
          headerRef={headerRef}
          bibleColorTheme={bibleColorTheme}
          isNoPlan={noPlanBible ? activeSession?.id : 0}
          readingPlanMenuContent={
            <SelectReadingPlanPopUp 
              readingPlanRecord={readingPlanRecord} 
              readingPlans={readingPlans} 
              navigateOnClick={true}
              userGroupIds={userGroupsIds}/>}
        ></BibleReadingHeader>
        <IonContent ref={pageContent} className="bible-reading-content">
          { activeSession &&
          <div className={`bible-font-${activeBibleSettings?.fontSize}`}>
            <DismissibleCard
            messageId={AppMessages.readingHeaderInstructions.messageId}
            hideCard={hideReadingHeaderInstructions}
            dismissCard={dismissReadingHeaderInstructions}
            color='bible'
            buttonText="Thanks, Got it!"
          >
            {AppMessages.readingHeaderInstructions.messageBody}
          </DismissibleCard>
            <CountDownTimer endDate={readingPlanRecord?.startDate} messageWhenComplete='' roundToDate={true}/>
            <div className="bible-reading-day-header">
              <IonGrid fixed={true}>
                <IonRow>
                  { readingPlanRecord?.sessionsPerDay > 1 ?
                  <IonCol>
                    {/* Multiple Sessions per Day Header*/}
                    <div className="bible-reading-intro">
                      <p>Reading #{activeSession?.session}</p>
                      <p className="bible-reading-intro-body cursor-pointer" onClick={()=>{ 
                        history.push(
                        `${AppRouteInfo[AppRouteKeys.ReadingScheduler].rootPath}/${readingPlanRecord?.readingPlanCode}/${readingPlanRecord?.id}`, {direction: 'forward'}) }}><IonIcon icon={calendar} className="bible-reading-inline-icon"></IonIcon>
                        <b>You are scheduled for {readingPlanRecord?.sessionsPerDay} readings/day</b></p>
                      <p className="bible-reading-intro-body">
                        <i>Today's readings include: {getTodaysReadings(activeSession?.session, scheduledReadingSession, readingPlanRecord?.sessionsPerDay)}</i></p>
                    </div>  
                    <div className="bible-reading-intro-divider"></div>  
                    <div className="bible-reading-intro-pace-body">
                      <p>{activeSession?.intro.body}</p>
                    </div>
                    <div className="bible-reading-intro-divider"></div>
                  </IonCol> : 
                  activeSession?.freeStyleBibleReading ? 
                  <IonCol>
                    {/* Freestyle Reading Header*/}
                    <div className="bible-reading-intro">
                      <p>{activeSession?.intro.title}</p>
                      <p className="bible-reading-intro-body">
                        <IonIcon icon={library} className="bible-reading-inline-icon"></IonIcon>
                        <b>
                          {activeSession?.intro.body}
                          <i>{activeSession?.intro.title.substring(0,3) === `Day` ? '': ` (Plan Day ${activeSession?.session})`}</i>
                        </b>
                      </p>
                    </div>
                    <div id="bible-passage-list-controls" className="bible-reading-intro-divider"></div>  
                    <div className="bible-reading-intro-freestyle-body">
                      <p><b>Today you will be reading as much as you can from the following passages:</b></p>
                      <ul className="verse-list-box-horizontal">
                        {freestyleVerseList(activeSession, 'header')}
                      </ul>
                    </div>
                    <div className="bible-reading-intro-divider"></div>
                  </IonCol> :
                  <IonCol>
                    {/* Classic One Session per Day Header*/}
                    <div className="bible-reading-intro">
                      <p>{activeSession?.intro.title}</p>
                      <p className="bible-reading-intro-body">
                        <IonIcon icon={library} className="bible-reading-inline-icon"></IonIcon>
                        <b>
                          {activeSession?.intro.body}
                          {noPlanBible ?
                            <i> (No Plan)</i> :
                            <i>{activeSession?.intro.title.substring(0,3) === `Day` ? '': ` (Plan Day ${activeSession?.session})`}</i>}
                        </b>
                      </p>
                    </div>
                    <div className="bible-reading-intro-divider"></div>
                  </IonCol>
                  }
                </IonRow>
              </IonGrid>
            </div>
            <div className="bible-reading-text">
            <IonGrid fixed={true}>
              <IonRow>
                <IonCol className="bible-reading-text-col">
                  { bibleText.length ?
                    renderBibleText(activeSession?.freeStyleBibleReading, bibleText, freestyleIndex) :
                    skeletonText()
                  }
                </IonCol>
              </IonRow>
              { activeSession?.freeStyleBibleReading &&
                  <IonRow>
                    <IonCol>
                      <div className="bible-reading-footer-pace-body">
                        <div className="bible-reading-footer-divider"></div>
                        { freestyleIndex < activeSession?.biblePassageList?.length - 1 &&
                          <div className="freestyle-next-passage-button" onClick={()=> updateActiveFreestyleIndex(freestyleIndex + 1, activeSession)}>Open Next Passage in Today's Reading <IonIcon className="icon-inline-text" icon={send}></IonIcon></div> }
                        <p className="bible-reading-intro-body"><b>Today's reading includes the following passages:</b></p>
                        <ul className="verse-list-box-horizontal">
                          {freestyleVerseList(activeSession, 'footer')}
                        </ul>
                        { freestyleIndex < activeSession?.biblePassageList?.length - 1 ?
                          <p className="bible-reading-intro-body"><i>Reading as much as you can from the above passages today. You can move to the next Bible passage by pushing the "Open Next Passage in Today's Reading" button or by tapping on the verse reference buttons above.</i></p> :
                          <p className="bible-reading-intro-body"><i>Reading as much as you can from the above passages today. <b>You are currently on the last passage for today.</b> By tapping on the verse reference buttons above, you can go back and read a different passage.</i></p>}
                        <div className="bible-reading-footer-divider"></div>
                      </div>  
                    </IonCol>
                  </IonRow>
              }
              { readingPlanRecord?.sessionsPerDay > 1 &&
                  <IonRow>
                    <IonCol>
                        
                      <div className="bible-reading-footer-pace-body">
                        <div className="bible-reading-footer-divider"></div>
                        <p className="bible-reading-intro-body cursor-pointer" onClick={()=>{ history.push(
                          `${AppRouteInfo[AppRouteKeys.ReadingScheduler].rootPath}/${readingPlanRecord?.readingPlanCode}/${readingPlanRecord?.id}`, {direction: 'forward'}) }}><IonIcon icon={calendar} className="bible-reading-inline-icon"></IonIcon>
                          <b>You are scheduled for {readingPlanRecord?.sessionsPerDay} readings/day</b></p>
                        <p className="bible-reading-intro-body">
                          <i>Today's readings include: {getTodaysReadings(activeSession?.session, scheduledReadingSession, readingPlanRecord?.sessionsPerDay)}</i></p>
                        <p className="bible-reading-intro-body"> To continue your readings for today, push the <IonText color={'primary'}><IonIcon icon={chevronForwardCircleSharp}></IonIcon></IonText> button at the bottom of the screen</p>
                          <div className="bible-reading-footer-divider"></div>
                      </div>
                      
                    </IonCol>
                  </IonRow>
              }
              <IonRow>
                <IonCol>
                  <div className="bible-reading-copyright">
                    {BibleVersionCopyright[getValidBibleVersion(version)]}
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
            </div>
            <div className="bible-reading-session-extras">
              <IonGrid fixed={true}>
                <IonRow>
                  {
                    AllBibleContent.map((bibleContent, index) => {
                      let contentExists = false;
                      if(activeSession[bibleContent] && Array.isArray(activeSession[bibleContent])) {
                        const contentArray = activeSession[bibleContent] as string[];
                        contentExists = !!contentArray.length && BibleContentData[bibleContent].location !== BibleContentLocation.inline;
                      } else {
                        contentExists = !!activeSession[bibleContent] && BibleContentData[bibleContent].location !== BibleContentLocation.inline;
                      }
                        
                      return contentExists &&
                        <IonCol key={`bible-content-button=${index}`} sizeXs="6" sizeSm="6" sizeMd="4" sizeLg="3" sizeXl="3">
                          <div className="bible-reading-extra-content" onClick={() => {
                            toggleBibleContentDisplay(bibleContent)
                            }}>
                            <IonCard mode="md">
                              <IonCardHeader>
                                <IonIcon icon={BibleContentData[bibleContent].icon}></IonIcon>
                              </IonCardHeader>
                              <IonCardContent>
                                {BibleContentData[bibleContent].name}
                              </IonCardContent>
                            </IonCard>
                          </div>
                        </IonCol>
                    })
                  }
                </IonRow>
              </IonGrid>
            </div>
            <div>
                { extraResourcesURL && <a className="extraResourcesImage" rel="noreferrer" target="_blank" href={readingPlanRecord?.readingPlanExtrasLink}><IonImg className="extraResourcesImage" src={extraResourcesURL} onIonError={(e:any) => setExtraResourcesURL('')}></IonImg></a>}
            </div>
          </div>
          }
          <IonModal
            isOpen={showModal}
            className="bible-reading-modal"
            // cssClass='bible-reading-modal'
            canDismiss={true}
            onDidDismiss={() => setShowModal(false)}>
            {renderBibleContent(activeModalContent)}
            <IonFab vertical="top" horizontal="end" slot="fixed">
              <IonFabButton onClick={() => setShowModal(false)}>
                <IonIcon icon={closeSharp} />
              </IonFabButton>
            </IonFab>
          </IonModal>
          { LinkSessionURL(-1) &&
            <IonFab vertical="bottom" horizontal="start" slot="fixed" className={showNavButtons ? 'bible-reading-nav' : 'bible-reading-nav-hidden'}>
              <IonFabButton size="small" color={AppRouteInfo[AppRouteKeys.Bible].themeColorName} 
                onClick={() => goToBibleSession(-1)}>
                <IonIcon color="light"  icon={chevronBack} />
              </IonFabButton>
            </IonFab>
          }
          { LinkSessionURL(1) &&
            <IonFab vertical="bottom" horizontal="end" slot="fixed" className={showNavButtons ? 'bible-reading-nav' : 'bible-reading-nav-hidden'}>
              <IonFabButton size="small" color={AppRouteInfo[AppRouteKeys.Bible].themeColorName} 
                onClick={() => goToBibleSession(1)}>
                <IonIcon color="light" icon={chevronForward} />
              </IonFabButton>
            </IonFab>
          }
          { audioBibleFile &&
            <IonFab vertical="bottom" horizontal="center" slot="fixed" className={showNavButtons && showSmallPlayButton ? 'bible-reading-nav' : 'bible-reading-nav-hidden'}>
              <IonFabButton color={AppRouteInfo[AppRouteKeys.Bible].themeColorName} onClick={() => startAudioPlayer()}>
                <IonIcon color="light" icon={play} className="bible-fab-play-button"/>
              </IonFabButton>
            </IonFab>
          }
          <IonToast color="success"
            isOpen={displayToastSuccess}
            onDidDismiss={() => setDisplayToastSuccess(false)}
            message={toastSuccessMessage}
            duration={2500} />
          <IonToast color="danger"
            isOpen={displayToastFailed}
            onDidDismiss={() => setDisplayToastFailed(false)}
            message={toastFailedMessage}
            duration={2500} />
          { showFeedbackModal && <FeedbackModal></FeedbackModal> }
          {completedReadingPlan()}
        </IonContent>
        <IonFooter mode="ios" className="bible-reading-footer">
          {
            (audioBibleFile && activeBibleSettings) && <BSTAudioPlayer 
              ref={audioPlayerRef}
              startPlaying={!showSmallPlayButton} 
              showPlayer={showAudioBible && !showSmallPlayButton} 
              audioUrl={audioBibleFile}
              initializedSpeed={activeBibleSettings?.audioSpeed ?? 1}
              onComplete={completedDay}
              onVerseChange={updateVerseScroll}
              stayAwake={!!activeBibleSettings?.audioScroll}></BSTAudioPlayer>
          }
          <div className={showFooterSlide ? 'bible-reading-footer-slide bible-reading-show-footer-slide' : 'bible-reading-footer-slide'}>
            <IonGrid fixed={true} className="bible-reading-footer-header-container">
              <IonRow>
                <IonCol>
                  <div className="bible-reading-footer-header">
                    <div className="bible-tab">
                      <div className="bible-reading-footer-title">{BibleContentData[activeFooterContent].name === 'Verse' ? 
                        selectedVerse?.displayReference :
                        BibleContentData[activeFooterContent].title}</div>
                      <div className="bible-reading-footer-buttons">
                          <IonIcon onClick={() => {toggleBibleContentDisplay(activeFooterContent)}} icon={closeCircle} />
                      </div>
                    </div>
                  </div> 
                </IonCol>
              </IonRow>
            </IonGrid>
            <div className="bible-reading-footer-content-container">
            <IonGrid fixed={true} >
              <IonRow >
                <IonCol className="bible-reading-footer-content">
                  {renderBibleContent(activeFooterContent)}
                  <div className="bible-footer-content-ios-safe-zone"></div>
                </IonCol>
              </IonRow>
            </IonGrid>
            </div>
          </div>        
        </IonFooter>
    </IonPage>
  );

  // -------------------------------------------------------------------
  // #endregion PageContentRender render page content
  // -------------------------------------------------------------------

};


export default BibleReadingPage;
